import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Container from "@mui/material/Container";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";

import LOGO from "../../semiauth.logo.png";
import { useAuth } from "./AuthProvider";

const Status = () => {
  const darkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const { auth } = useAuth();
  const navigate = useNavigate();
  const toHome = () => navigate("/welcome");

  useEffect(() => {
    if (auth) navigate("/");
  }, [auth]);

  useEffect(() => {
    document.title = "[semiauth] | status";
  }, []); // run once on mount

  return (
    <Container
      maxWidth="sm"
      component="main"
      sx={{
        display: "flex",
        textAlign: "center",
        alignItems: "center",
        marginBlock: "auto",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      {/* <div style={{ display: "flex", justifyContent: "center" }}>
        {darkMode ? (
          <img src={LogoWhite} alt="Logo 2" className="logo" />
        ) : (
          <img src={LogoBlack} alt="Logo 1" className="logo" />
        )}
      </div> */}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <img src={LOGO} alt="[semiauth] logo" className="logo" />

        <Box sx={{ my: 5 }}>
          <Typography>
            Your profile has been created. An administrator has been notified
            and will activate your account at their earliest convenience.
          </Typography>
        </Box>
      </Box>

      <Button variant="contained" onClick={toHome}>
        Home
      </Button>
    </Container>
  );
};

export default Status;
